import * as React from "react";

const AvailabilityInStock: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
        >
            <path d="m 7.9999971,20.666531 c -0.3636364,0 -0.7272727,-0.12121 -0.969697,-0.363629 L 0.36363354,13.636363 c -0.48484848,-0.484839 -0.48484848,-1.333307 0,-1.939356 0.48484848,-0.606049 1.33333336,-0.484839 1.93939396,0 L 7.9999971,17.393867 21.696967,3.6971606 c 0.484848,-0.4848392 1.333333,-0.4848392 1.939394,0 0.484848,0.4848391 0.484848,1.3333077 0,1.9393566 L 8.9696941,20.302902 c -0.2424243,0.242419 -0.6060606,0.363629 -0.969697,0.363629 z" />
        </svg>
    );
};

export default React.memo(AvailabilityInStock);
